interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const MenkyoUraIcon = (props: PropsType) => (
  <svg width="100" height="68" viewBox="0 0 100 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1109_2149)">
      <path
        d="M90.6604 68H9.3396C4.19067 68 0 63.8454 0 58.737V9.26129C0 4.15457 4.18891 0 9.3396 0H90.6604C95.8093 0 100 4.15457 100 9.26129V58.737C100 63.8437 95.8111 68 90.6604 68ZM9.3396 5.73742C7.38079 5.73742 5.78661 7.31853 5.78661 9.26129V58.737C5.78661 60.6797 7.38079 62.2608 9.3396 62.2608H90.6604C92.6192 62.2608 94.2134 60.6797 94.2134 58.737V9.26129C94.2134 7.31853 92.6192 5.73742 90.6604 5.73742H9.3396Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
      <path d="M89.2863 37.579H10.7148V39.3685H89.2863V37.579Z" fill={props.color ? props.color : '#c3c3c3'} />
      <path d="M89.2863 16.1053H10.7148V17.8948H89.2863V16.1053Z" fill={props.color ? props.color : '#c3c3c3'} />
      <path d="M89.2863 26.8421H10.7148V28.6316H89.2863V26.8421Z" fill={props.color ? props.color : '#c3c3c3'} />
    </g>
    <defs>
      <clipPath id="clip0_1109_2149">
        <rect width="100" height="68" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MenkyoUraIcon;
